var _mask, _path, _mask2, _path2, _mask3, _path3, _mask4, _path4, _path5, _path6, _rect, _rect2, _rect3, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLaskinIkoni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_101_37",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9995 0H45.6904V43.309L88.9994 43.309V19.9376C88.9658 8.92059 80.0244 0 68.9995 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6904 0V-1H44.6904V0H45.6904ZM45.6904 43.309H44.6904V44.309L45.6904 44.309L45.6904 43.309ZM88.9994 43.309L88.9994 44.309L89.9994 44.309V43.309H88.9994ZM88.9994 19.9376H89.9994L89.9994 19.9345L88.9994 19.9376ZM45.6904 1H68.9995V-1H45.6904V1ZM46.6904 43.309V0H44.6904V43.309H46.6904ZM88.9994 42.309L45.6904 42.309L45.6904 44.309L88.9994 44.309L88.9994 42.309ZM87.9994 19.9376V43.309H89.9994V19.9376H87.9994ZM68.9995 1C79.4731 1 87.9675 9.47456 87.9994 19.9406L89.9994 19.9345C89.9641 8.36661 80.5756 -1 68.9995 -1V1Z",
    fill: "#2B2B2B",
    mask: "url(#path-1-inside-1_101_37)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_101_37",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.9935C0.00348032 8.97163 8.92273 0.0337354 19.9376 7.78921e-05L43.309 7.68705e-05L43.309 43.3091L0 43.3091L-1.01887e-06 20C-1.01897e-06 19.9979 -6.79326e-07 19.9957 0 19.9935Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.9935L-1 19.9932L0 19.9935ZM19.9376 7.78921e-05L19.9376 -0.999927L19.9345 -0.999917L19.9376 7.78921e-05ZM43.309 7.68705e-05L44.309 7.69148e-05L44.309 -0.999923L43.309 -0.999923L43.309 7.68705e-05ZM43.309 43.3091L43.309 44.3091L44.309 44.3091L44.309 43.3091L43.309 43.3091ZM0 43.3091L-1 43.3091L-1 44.3091L4.37114e-08 44.3091L0 43.3091ZM1 19.9939C1.00331 9.52307 9.4766 1.03205 19.9406 1.00007L19.9345 -0.999917C8.36886 -0.964577 -0.996346 8.4202 -1 19.9932L1 19.9939ZM19.9376 1.00008L43.309 1.00008L43.309 -0.999923L19.9376 -0.999922L19.9376 1.00008ZM42.309 7.68261e-05L42.309 43.3091L44.309 43.3091L44.309 7.69148e-05L42.309 7.68261e-05ZM43.309 42.3091L-4.37114e-08 42.3091L4.37114e-08 44.3091L43.309 44.3091L43.309 42.3091ZM1 43.3091L0.999999 20L-1 20L-1 43.3091L1 43.3091ZM0.999999 20C0.999999 19.998 0.999999 19.9959 1 19.9939L-1 19.9932C-1 19.9955 -1 19.9977 -1 20L0.999999 20Z",
    fill: "#2B2B2B",
    mask: "url(#path-3-inside-2_101_37)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_101_37",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9834 88.5667C8.96637 88.5574 0.0342121 79.6404 0.000565538 68.6291L0.000563495 45.2576L43.3096 45.2576L43.3096 88.5667L19.9834 88.5667Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9834 88.5667L19.9826 89.5667L19.9834 89.5667L19.9834 88.5667ZM0.000565538 68.6291L-0.999439 68.6291L-0.99943 68.6321L0.000565538 68.6291ZM0.000563495 45.2576L0.000563496 44.2576L-0.999437 44.2576L-0.999437 45.2576L0.000563495 45.2576ZM43.3096 45.2576L44.3096 45.2576L44.3096 44.2576L43.3096 44.2576L43.3096 45.2576ZM43.3096 88.5667L43.3096 89.5667L44.3096 89.5667L44.3096 88.5667L43.3096 88.5667ZM19.9842 87.5667C9.5181 87.5579 1.03252 79.0867 1.00056 68.626L-0.99943 68.6321C-0.964101 80.1941 8.41465 89.557 19.9826 89.5667L19.9842 87.5667ZM1.00057 68.6291L1.00056 45.2576L-0.999437 45.2576L-0.999434 68.6291L1.00057 68.6291ZM0.000563495 46.2576L43.3096 46.2576L43.3096 44.2576L0.000563496 44.2576L0.000563495 46.2576ZM42.3096 45.2576L42.3096 88.5667L44.3096 88.5667L44.3096 45.2576L42.3096 45.2576ZM43.3096 87.5667L19.9834 87.5667L19.9834 89.5667L43.3096 89.5667L43.3096 87.5667Z",
    fill: "#2B2B2B",
    mask: "url(#path-5-inside-3_101_37)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4_101_37",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.691 45.2581L89 45.2581L89 68.5669C89 79.6126 80.0457 88.5669 69 88.5669L45.691 88.5669L45.691 45.2581Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.691 45.2581L89 45.2581L89 68.5669C89 79.6126 80.0457 88.5669 69 88.5669L45.691 88.5669L45.691 45.2581Z",
    fill: "#E6E6E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.691 45.2581L45.691 44.2581L44.691 44.2581L44.691 45.2581L45.691 45.2581ZM89 45.2581L90 45.2581L90 44.2581L89 44.2581L89 45.2581ZM69 88.5669L69 87.5669L69 88.5669ZM45.691 88.5669L44.691 88.5669L44.691 89.5669L45.691 89.5669L45.691 88.5669ZM45.691 46.2581L89 46.2581L89 44.2581L45.691 44.2581L45.691 46.2581ZM88 45.2581L88 68.5669L90 68.5669L90 45.2581L88 45.2581ZM88 68.5669C88 79.0603 79.4934 87.5669 69 87.5669L69 89.5669C80.598 89.5669 90 80.1648 90 68.5669L88 68.5669ZM69 87.5669L45.691 87.5669L45.691 89.5669L69 89.5669L69 87.5669ZM46.691 88.5669L46.691 45.2581L44.691 45.2581L44.691 88.5669L46.691 88.5669Z",
    fill: "#2B2B2B",
    mask: "url(#path-7-inside-4_101_37)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1704 12.9924H20.3553V20.355H12.9932V23.17H20.3553V30.316H23.1704V23.17H30.3168V20.355H23.1704V12.9924Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76.0078,
    y: 62.7981,
    width: 2.81509,
    height: 17.3236,
    transform: "rotate(90 76.0078 62.7981)",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 76.0078,
    y: 67.9951,
    width: 2.81509,
    height: 17.3236,
    transform: "rotate(90 76.0078 67.9951)",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 76.0078,
    y: 21.6543,
    width: 2.81509,
    height: 17.3236,
    transform: "rotate(90 76.0078 21.6543)",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6252 61.6002L26.6117 59.5867L21.4773 64.7211L16.343 59.5868L14.3294 61.6003L19.4637 66.7346L14.3291 71.8693L16.3426 73.8828L21.4773 68.7482L26.612 73.8829L28.6255 71.8694L23.4908 66.7346L28.6252 61.6002Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaskinIkoni);
export default __webpack_public_path__ + "static/media/Laskin_ikoni.82150b51b099c67e4486bc7a2d7637a6.svg";
export { ForwardRef as ReactComponent };